<script lang="ts" setup>
    import { EinvoicingReceivingLifecycleStatus, LIFECYCLE_STATUS_CONFIG, lifecycleStatusLabelKey } from '~/app/einvoicing/enums/EinvoicingReceivingLifecycleStatus';

    const props = defineProps<{
        status: EinvoicingReceivingLifecycleStatus | null;
    }>();

    const config = computed(() => (props.status ? LIFECYCLE_STATUS_CONFIG[props.status] : null));

    // Pill tones aligned on the tp-pro design system (same palette as UiStatusBadge).
    const TONE: Record<string, string> = {
        info: 'bg-badgestatus-blue text-blue-900',
        warning: 'bg-badgestatus-orange text-[#997500]',
        success: 'bg-badgestatus-green text-[#154937]',
        danger: 'bg-badgestatus-red text-red-700',
        neutral: 'bg-badgestatus-gray text-zinc-600',
    };
</script>

<template>
    <span
        v-if="status && config"
        class="inline-flex items-center gap-1.5 rounded-full px-2 py-1 md:px-3 md:py-1.5 text-xs font-medium"
        :class="TONE[config.tone]"
    >
        <i
            class="fa-solid text-[10px]"
            :class="config.icon"
        />
        {{ $t(lifecycleStatusLabelKey(status)) }}
    </span>
</template>
